/**import {useForm} from 'react-hook-form'
//import {useState} from 'react'
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {addDoc, collection} from 'firebase/firestore';
import {auth, db} from '../../config/firebase';
import {useAuthState} from "react-firebase-hooks/auth";
import {useNavigate} from 'react-router-dom'
import '../../App.css';
//import {useState, useRef} from 'react';
import './post.css';


interface CreateFormData {
    title: string;
    description: string;
    hyperlink?: string;
    pdflink ?: string;
    selectedCourseOption: string;
    selectedSchoolOption: string;
    selectedUnitOption: string;

}


export const CreateForm = () => {
    const [user] = useAuthState(auth);
    const navigate = useNavigate();
    
    const schema = yup.object().shape({
        title: yup.string().required("You must add a title."),
        description: yup.string().required("Please add a short description."),
        hyperlink: yup.string().url("Must be a valid URL. Make sure to add https://"),
        pdflink: yup.string().url("Must be a valid PDF URL. Make sure to add https://"),
        selectedCourseOption: yup.string().required('Please select a course'),
        selectedSchoolOption: yup.string().required('Please select a school.'),
        selectedUnitOption: yup.string().required('Please select a unit.'),
    });

    const{register, handleSubmit, formState: {errors},} = useForm<CreateFormData>({
        resolver: yupResolver(schema),
    })

    const postsRef = collection(db, "posts")

    const onCreatePost = async (data: CreateFormData) => {
        await addDoc(postsRef, {
            title: data.title,
            description: data.description,
            hyperlink: data.hyperlink,
            pdflink: data.pdflink,
            username: user?.displayName,
            userId: user?.uid,
            selectedCourseOption: data.selectedCourseOption,
            selectedSchoolOption: data.selectedSchoolOption,
            selectedUnitOption: data.selectedUnitOption,
        });

        navigate("/");


    }


    return(
        <div>
        <h1><span className="gradient-text-ace">Upload Assignment</span></h1>
        <form onSubmit={handleSubmit(onCreatePost)} className="forms-wrapper">
            <div className="assignment-container">
            <input placeholder="Title..." {...register("title")} className="titleinput"/>
            <p style={{color:"red"}}>{errors.title?.message}</p>
            <textarea placeholder="Write a short description here"{...register("description")}  className="textArea"/>
            <p style={{color: "red"}}>{errors.description?.message}</p>
            <br />
            
            <input placeholder="Paste hyperlink here" {...register("hyperlink")} className="hyperlink-width" />
            <p style={{color:"red"}}>{errors.hyperlink?.message}</p>
            <input placeholder="Paste PDF link here" {...register("pdflink")} className="hyperlink-width" />
            <p style={{color: "red"}}>{errors.pdflink?.message}</p>
            </div>
            <br />
            <div className="course-container">
            <h3>Course:</h3>
            <select {...register("selectedCourseOption")} className="uploadcursor">
                <option value="AP Computer Science Principles">AP Computer Science Principles</option>
                <option value="AP Human Geography">AP Human Geography</option>
                <option value="Add New Course">Add New Course</option>
            </select>

            <p style={{color:"red"}}>{errors.selectedCourseOption?.message}</p>
            <h3>School:</h3>
            <select {...register("selectedSchoolOption")} className="uploadcursor">
                <option value="Plano East Senior High">Plano East Senior High</option>
                <option value="Plano West Senior High">Plano West Senior High</option>
                <option value="John Paul II High School">John Paul II High School</option>
                <option value="Independence High School">Independence High School</option>
            </select>
            <p style={{color:"red"}}>{errors.selectedSchoolOption?.message}</p>
            <h3>Unit:</h3>
            <input {...register("selectedUnitOption")} className="hyperlink-width"/>
            <p style={{color:"red"}}>{errors.selectedUnitOption?.message}</p>
            
            <br></br><br></br>
            <input type="submit" className="custom-red-button" value="Post" />            <br />
            
            </div>
           
        </form>
        </div>
    );
}**/

/**import {useForm} from 'react-hook-form'
import {useState, useEffect} from 'react'
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {addDoc, collection, getDocs, query, where, doc, setDoc} from 'firebase/firestore';
import {auth, db} from '../../config/firebase';
import {useAuthState} from "react-firebase-hooks/auth";
import {useNavigate} from 'react-router-dom'
import '../../App.css';
import './post.css';

interface CreateFormData {
    title: string;
    description: string;
    hyperlink?: string;
    pdflink ?: string;
    selectedCourseOption: string;
    selectedSchoolOption: string;
    selectedUnitOption: string;
}

interface School {
    id: string;
    name: string;
    createdBy: string;
    createdAt: Date;
}

interface Course {
    id: string;
    name: string;
    schoolId: string;
    createdBy: string;
    createdAt: Date;
}

interface UserRole {
    isAdmin: boolean;
    canManageCourses: boolean;
    allowedSchools?: string[]; // For course managers - which schools they can manage
}

export const CreateForm = () => {
    const [user] = useAuthState(auth);
    const navigate = useNavigate();
    
    // State for dynamic options
    const [schools, setSchools] = useState<School[]>([]);
    const [courses, setCourses] = useState<Course[]>([]);
    const [units, setUnits] = useState<string[]>([]);
    const [userRole, setUserRole] = useState<UserRole>({ isAdmin: false, canManageCourses: false });
    
    // State for new additions
    const [showNewSchoolInput, setShowNewSchoolInput] = useState(false);
    const [showNewCourseInput, setShowNewCourseInput] = useState(false);
    const [showNewUnitInput, setShowNewUnitInput] = useState(false);
    const [newSchoolName, setNewSchoolNae] = useState('');
    const [newCourseName, setNewCourseName] = useState('');
    const [newUnitName, setNewUnitName] = useState('');
    
    // Form state
    const [selectedSchool, setSelectedSchool] = useState('');
    const [selectedCourse, setSelectedCourse] = useState('');

    const schema = yup.object().shape({
        title: yup.string().required("You must add a title."),
        description: yup.string().required("Please add a short description."),
        hyperlink: yup.string().url("Must be a valid URL. Make sure to add https://"),
        pdflink: yup.string().url("Must be a valid PDF URL. Make sure to add https://"),
        selectedCourseOption: yup.string().required('Please select a course'),
        selectedSchoolOption: yup.string().required('Please select a school.'),
        selectedUnitOption: yup.string().required('Please select a unit.'),
    });

    const{register, handleSubmit, formState: {errors}, setValue, watch} = useForm<CreateFormData>({
        resolver: yupResolver(schema),
    });

    // Watch for changes in school and course selection
    const watchedSchool = watch("selectedSchoolOption");
    const watchedCourse = watch("selectedCourseOption");

    // Fetch user role and permissions
    useEffect(() => {
        const fetchUserRole = async () => {
            if (!user?.uid) return;
            
            try {
                const userRoleDoc = await getDocs(
                    query(collection(db, "userRoles"), where("userId", "==", user.uid))
                );
                
                if (!userRoleDoc.empty) {
                    const roleData = userRoleDoc.docs[0].data() as UserRole;
                    setUserRole(roleData);
                } else {
                    // Default role for new users
                    setUserRole({ isAdmin: false, canManageCourses: false });
                }
            } catch (error) {
                console.error("Error fetching user role:", error);
            }
        };

        fetchUserRole();
    }, [user]);

    // Fetch schools
    useEffect(() => {
        const fetchSchools = async () => {
            try {
                const schoolsSnapshot = await getDocs(collection(db, "schools"));
                const schoolsData = schoolsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                })) as School[];
                setSchools(schoolsData.sort((a, b) => a.name.localeCompare(b.name)));
            } catch (error) {
                console.error("Error fetching schools:", error);
            }
        };

        fetchSchools();
    }, []);

    // Fetch courses when school changes
    useEffect(() => {
        const fetchCourses = async () => {
            if (!watchedSchool) {
                setCourses([]);
                return;
            }

            try {
                const selectedSchoolObj = schools.find(s => s.name === watchedSchool);
                if (!selectedSchoolObj) return;

                const coursesSnapshot = await getDocs(
                    query(collection(db, "courses"), where("schoolId", "==", selectedSchoolObj.id))
                );
                
                const coursesData = coursesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                })) as Course[];
                
                setCourses(coursesData.sort((a, b) => a.name.localeCompare(b.name)));
            } catch (error) {
                console.error("Error fetching courses:", error);
            }
        };

        fetchCourses();
        setSelectedSchool(watchedSchool);
        // Reset course selection when school changes
        setValue("selectedCourseOption", "");
        setSelectedCourse("");
    }, [watchedSchool, schools, setValue]);

    // Fetch units when course changes
    useEffect(() => {
        const fetchUnits = async () => {
            if (!watchedSchool || !watchedCourse) {
                setUnits([]);
                return;
            }

            try {
                const postsSnapshot = await getDocs(
                    query(
                        collection(db, "posts"),
                        where("selectedSchoolOption", "==", watchedSchool),
                        where("selectedCourseOption", "==", watchedCourse)
                    )
                );

                const unitsSet = new Set<string>();
                postsSnapshot.docs.forEach(doc => {
                    const data = doc.data();
                    if (data.selectedUnitOption) {
                        unitsSet.add(data.selectedUnitOption);
                    }
                });

                setUnits(Array.from(unitsSet).sort());
            } catch (error) {
                console.error("Error fetching units:", error);
            }
        };

        fetchUnits();
        setSelectedCourse(watchedCourse);
    }, [watchedCourse, watchedSchool]);

    // Add new school (Admin only)
    const handleAddNewSchool = async () => {
        if (!newSchoolName.trim() || !userRole.isAdmin) return;

        try {
            const newSchoolRef = doc(collection(db, "schools"));
            await setDoc(newSchoolRef, {
                name: newSchoolName.trim(),
                createdBy: user?.uid,
                createdAt: new Date()
            });

            // Refresh schools list
            const schoolsSnapshot = await getDocs(collection(db, "schools"));
            const schoolsData = schoolsSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })) as School[];
            setSchools(schoolsData.sort((a, b) => a.name.localeCompare(b.name)));

            // Set the new school as selected
            setValue("selectedSchoolOption", newSchoolName.trim());
            setNewSchoolName('');
            setShowNewSchoolInput(false);
        } catch (error) {
            console.error("Error adding new school:", error);
        }
    };

    // Add new course (Admin or Course Manager)
    const handleAddNewCourse = async () => {
        if (!newCourseName.trim() || !selectedSchool || (!userRole.isAdmin && !userRole.canManageCourses)) return;

        const selectedSchoolObj = schools.find(s => s.name === selectedSchool);
        if (!selectedSchoolObj) return;

        // Check if course manager has permission for this school
        if (userRole.canManageCourses && !userRole.isAdmin) {
            if (userRole.allowedSchools && !userRole.allowedSchools.includes(selectedSchoolObj.id)) {
                alert("You don't have permission to manage courses for this school.");
                return;
            }
        }

        try {
            const newCourseRef = doc(collection(db, "courses"));
            await setDoc(newCourseRef, {
                name: newCourseName.trim(),
                schoolId: selectedSchoolObj.id,
                createdBy: user?.uid,
                createdAt: new Date()
            });

            // Refresh courses list
            const coursesSnapshot = await getDocs(
                query(collection(db, "courses"), where("schoolId", "==", selectedSchoolObj.id))
            );
            const coursesData = coursesSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })) as Course[];
            setCourses(coursesData.sort((a, b) => a.name.localeCompare(b.name)));

            // Set the new course as selected
            setValue("selectedCourseOption", newCourseName.trim());
            setNewCourseName('');
            setShowNewCourseInput(false);
        } catch (error) {
            console.error("Error adding new course:", error);
        }
    };

    const onCreatePost = async (data: CreateFormData) => {
        const postsRef = collection(db, "posts");
        
        await addDoc(postsRef, {
            title: data.title,
            description: data.description,
            hyperlink: data.hyperlink,
            pdflink: data.pdflink,
            username: user?.displayName,
            userId: user?.uid,
            selectedCourseOption: data.selectedCourseOption,
            selectedSchoolOption: data.selectedSchoolOption,
            selectedUnitOption: data.selectedUnitOption,
            createdAt: new Date()
        });

        navigate("/");
    };

    const canManageCoursesForSchool = (schoolName: string) => {
        if (userRole.isAdmin) return true;
        if (!userRole.canManageCourses) return false;
        
        const selectedSchoolObj = schools.find(s => s.name === schoolName);
        if (!selectedSchoolObj) return false;
        
        return userRole.allowedSchools?.includes(selectedSchoolObj.id) || false;
    };

    return(
        <div>
            <h1><span className="gradient-text-ace">Upload Assignment</span></h1>
            <form onSubmit={handleSubmit(onCreatePost)} className="forms-wrapper">
                <div className="assignment-container">
                    <input placeholder="Title..." {...register("title")} className="titleinput"/>
                    <p style={{color:"red"}}>{errors.title?.message}</p>
                    <textarea placeholder="Write a short description here"{...register("description")}  className="textArea"/>
                    <p style={{color: "red"}}>{errors.description?.message}</p>
                    <br />
                    
                    <input placeholder="Paste hyperlink here" {...register("hyperlink")} className="hyperlink-width" />
                    <p style={{color:"red"}}>{errors.hyperlink?.message}</p>
                    <input placeholder="Paste PDF link here" {...register("pdflink")} className="hyperlink-width" />
                    <p style={{color: "red"}}>{errors.pdflink?.message}</p>
                </div>
                <br />
                
                <div className="course-container">
                    
                    <h3>School:</h3>
                    <select {...register("selectedSchoolOption")} className="uploadcursor">
                        <option value="">Select a school</option>
                        {schools.map((school) => (
                            <option key={school.id} value={school.name}>{school.name}</option>
                        ))}
                        {userRole.isAdmin && (
                            <option value="__add_new__">+ Add New School</option>
                        )}
                    </select>
                    <p style={{color:"red"}}>{errors.selectedSchoolOption?.message}</p>

                    
                    {watchedSchool === "__add_new__" && userRole.isAdmin && (
                        <div style={{ marginTop: '10px' }}>
                            <input
                                type="text"
                                placeholder="Enter new school name"
                                value={newSchoolName}
                                onChange={(e) => setNewSchoolName(e.target.value)}
                                className="hyperlink-width"
                            />
                            <button
                                type="button"
                                onClick={handleAddNewSchool}
                                style={{ marginLeft: '10px', padding: '5px 10px' }}
                            >
                                Add School
                            </button>
                        </div>
                    )}

                    
                    <h3>Course:</h3>
                    <select 
                        {...register("selectedCourseOption")} 
                        className="uploadcursor"
                        disabled={!selectedSchool || selectedSchool === "__add_new__"}
                    >
                        <option value="">Select a course</option>
                        {courses.map((course) => (
                            <option key={course.id} value={course.name}>{course.name}</option>
                        ))}
                        {selectedSchool && selectedSchool !== "__add_new__" && canManageCoursesForSchool(selectedSchool) && (
                            <option value="__add_new__">+ Add New Course</option>
                        )}
                    </select>
                    <p style={{color:"red"}}>{errors.selectedCourseOption?.message}</p>

                   
                    {watchedCourse === "__add_new__" && canManageCoursesForSchool(selectedSchool) && (
                        <div style={{ marginTop: '10px' }}>
                            <input
                                type="text"
                                placeholder="Enter new course name"
                                value={newCourseName}
                                onChange={(e) => setNewCourseName(e.target.value)}
                                className="hyperlink-width"
                            />
                            <button
                                type="button"
                                onClick={handleAddNewCourse}
                                style={{ marginLeft: '10px', padding: '5px 10px' }}
                            >
                                Add Course
                            </button>
                        </div>
                    )}

                    
                    <h3>Unit:</h3>
                    {!showNewUnitInput ? (
                        <div>
                            <select 
                                {...register("selectedUnitOption")} 
                                className="uploadcursor"
                                disabled={!selectedCourse || selectedCourse === "__add_new__"}
                                onChange={(e) => {
                                    if (e.target.value === "__add_new__") {
                                        setShowNewUnitInput(true);
                                        setValue("selectedUnitOption", "");
                                    }
                                }}
                            >
                                <option value="">Select a unit</option>
                                {units.map((unit, index) => (
                                    <option key={index} value={unit}>{unit}</option>
                                ))}
                                <option value="__add_new__">+ Add New Unit</option>
                            </select>
                        </div>
                    ) : (
                        <div>
                            <input
                                {...register("selectedUnitOption")}
                                placeholder="Enter new unit name"
                                className="hyperlink-width"
                            />
                            <button
                                type="button"
                                onClick={() => {
                                    setShowNewUnitInput(false);
                                    setValue("selectedUnitOption", "");
                                }}
                                style={{ marginLeft: '10px', padding: '5px 10px' }}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                    <p style={{color:"red"}}>{errors.selectedUnitOption?.message}</p>
                    
                    <br></br><br></br>
                    <input type="submit" className="custom-red-button" value="Post" />
                    <br />
                </div>
            </form>
        </div>
    );
}*/

import {useForm} from 'react-hook-form'
import {useState, useEffect} from 'react'
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {addDoc, collection, getDocs, query, where, doc, setDoc, serverTimestamp, Timestamp} from 'firebase/firestore';
import {auth, db} from '../../config/firebase';
import {useAuthState} from "react-firebase-hooks/auth";
import {useNavigate} from 'react-router-dom'
import '../../App.css';
import './post.css';

interface CreateFormData {
    title: string;
    description: string;
    hyperlink?: string;
    pdflink ?: string;
    selectedCourseOption: string;
    selectedSchoolOption: string;
    selectedUnitOption: string;
}

interface School {
    id: string;
    name: string;
    createdBy: string;
    createdAt: Timestamp;
}

interface Course {
    id: string;
    name: string;
    schoolId: string;
    createdBy: string;
    createdAt: Timestamp;
}

interface UserRole {
    isAdmin: boolean;
    canManageCourses: boolean;
    canViewPosts: boolean;       
    canCreatePosts: boolean;     
    canManageUnits: boolean;
    allowedSchools?: string[]; 
}

export const CreateForm = () => {
    const [user] = useAuthState(auth);
    const navigate = useNavigate();
    
    // State for dynamic options
    const [schools, setSchools] = useState<School[]>([]);
    const [courses, setCourses] = useState<Course[]>([]);
    const [units, setUnits] = useState<string[]>([]);
    const [userRole, setUserRole] = useState<UserRole>({ 
        isAdmin: false, 
        canManageCourses: false,
        canViewPosts: false,       
        canCreatePosts: false,    
        canManageUnits: false       
    });
    
    // State for new additions
    const [showNewUnitInput, setShowNewUnitInput] = useState(false);
    const [newSchoolName, setNewSchoolName] = useState('');
    const [newCourseName, setNewCourseName] = useState('');
    
    // Form state
    const [selectedSchool, setSelectedSchool] = useState('');
    const [selectedCourse, setSelectedCourse] = useState('');

    const schema = yup.object().shape({
        title: yup.string().required("You must add a title."),
        description: yup.string().required("Please add a short description."),
        hyperlink: yup.string().url("Must be a valid URL. Make sure to add https://"),
        pdflink: yup.string().url("Must be a valid PDF URL. Make sure to add https://"),
        selectedCourseOption: yup.string().required('Please select a course'),
        selectedSchoolOption: yup.string().required('Please select a school.'),
        selectedUnitOption: yup.string().required('Please select a unit.'),
    });

    const{register, handleSubmit, formState: {errors}, setValue, watch} = useForm<CreateFormData>({
        resolver: yupResolver(schema),
    });

    // Watch for changes in school and course selection
    const watchedSchool = watch("selectedSchoolOption");
    const watchedCourse = watch("selectedCourseOption");

    // Fetch user role and permissions
    useEffect(() => {
        const fetchUserRole = async () => {
            if (!user?.uid) return;
            
            try {
                const userRoleDoc = await getDocs(
                    query(collection(db, "userRoles"), where("userId", "==", user.uid))
                );
                
                if (!userRoleDoc.empty) {
                    const roleData = userRoleDoc.docs[0].data() as UserRole;
                    setUserRole(roleData);
                } else {
                    // Default role for new users
                    setUserRole({ 
                        isAdmin: false, 
                        canManageCourses: false,
                        canViewPosts: true,        
                        canCreatePosts: false,      
                        canManageUnits: false       
                    });
                }
            } catch (error) {
                console.error("Error fetching user role:", error);
            }
        };

        fetchUserRole();
    }, [user]);

    // Fetch schools
    useEffect(() => {
        const fetchSchools = async () => {
            try {
                const schoolsSnapshot = await getDocs(collection(db, "schools"));
                const schoolsData = schoolsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                })) as School[];
                setSchools(schoolsData.sort((a, b) => a.name.localeCompare(b.name)));
            } catch (error) {
                console.error("Error fetching schools:", error);
            }
        };

        fetchSchools();
    }, []);

    // Fetch courses when school changes
    useEffect(() => {
        const fetchCourses = async () => {
            if (!watchedSchool) {
                setCourses([]);
                return;
            }

            try {
                const selectedSchoolObj = schools.find(s => s.name === watchedSchool);
                if (!selectedSchoolObj) return;

                const coursesSnapshot = await getDocs(
                    query(collection(db, "courses"), where("schoolId", "==", selectedSchoolObj.id))
                );
                
                const coursesData = coursesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                })) as Course[];
                
                setCourses(coursesData.sort((a, b) => a.name.localeCompare(b.name)));
            } catch (error) {
                console.error("Error fetching courses:", error);
            }
        };

        fetchCourses();
        setSelectedSchool(watchedSchool);
        // Reset course selection when school changes
        setValue("selectedCourseOption", "");
        setSelectedCourse("");
    }, [watchedSchool, schools, setValue]);

    // Fetch units when course changes
    useEffect(() => {
        const fetchUnits = async () => {
            if (!watchedSchool || !watchedCourse) {
                setUnits([]);
                return;
            }

            try {
                const postsSnapshot = await getDocs(
                    query(
                        collection(db, "posts"),
                        where("selectedSchoolOption", "==", watchedSchool),
                        where("selectedCourseOption", "==", watchedCourse)
                    )
                );

                const unitsSet = new Set<string>();
                postsSnapshot.docs.forEach(doc => {
                    const data = doc.data();
                    if (data.selectedUnitOption) {
                        unitsSet.add(data.selectedUnitOption);
                    }
                });

                setUnits(Array.from(unitsSet).sort());
            } catch (error) {
                console.error("Error fetching units:", error);
            }
        };

        fetchUnits();
        setSelectedCourse(watchedCourse);
    }, [watchedCourse, watchedSchool]);

    // Debug logging
    useEffect(() => {
        console.log("=== DEBUG INFO ===");
        console.log("selectedSchool:", selectedSchool);
        console.log("watchedSchool:", watchedSchool);
        console.log("userRole:", userRole);
        console.log("canManageCoursesForSchool result:", canManageCoursesForSchool(selectedSchool));
        console.log("courses array:", courses);
        console.log("condition result:", selectedSchool && selectedSchool !== "__add_new__" && canManageCoursesForSchool(selectedSchool));
        console.log("=================");
    }, [selectedSchool, watchedSchool, userRole, courses]);

    // Add new school (Admin only)
    const handleAddNewSchool = async () => {
        if (!newSchoolName.trim() || !userRole.isAdmin) return;

        try {
            const newSchoolRef = doc(collection(db, "schools"));
            await setDoc(newSchoolRef, {
                name: newSchoolName.trim(),
                createdBy: user?.uid,
                createdAt: serverTimestamp()
            });

            // Refresh schools list
            const schoolsSnapshot = await getDocs(collection(db, "schools"));
            const schoolsData = schoolsSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })) as School[];
            setSchools(schoolsData.sort((a, b) => a.name.localeCompare(b.name)));

            // Set the new school as selected
            setValue("selectedSchoolOption", newSchoolName.trim());
            setNewSchoolName('');
        } catch (error) {
            console.error("Error adding new school:", error);
        }
    };

    // Add new course (Admin or Course Manager)
    const handleAddNewCourse = async () => {
        if (!newCourseName.trim() || !selectedSchool || (!userRole.isAdmin && !userRole.canManageCourses)) return;

        const selectedSchoolObj = schools.find(s => s.name === selectedSchool);
        if (!selectedSchoolObj) return;

        // Check if course manager has permission for this school
        if (userRole.canManageCourses && !userRole.isAdmin) {
            if (userRole.allowedSchools && !userRole.allowedSchools.includes(selectedSchoolObj.id)) {
                alert("You don't have permission to manage courses for this school.");
                return;
            }
        }

        try {
            const newCourseRef = doc(collection(db, "courses"));
            await setDoc(newCourseRef, {
                name: newCourseName.trim(),
                schoolId: selectedSchoolObj.id,
                createdBy: user?.uid,
                createdAt: serverTimestamp()
            });

            // Refresh courses list
            const coursesSnapshot = await getDocs(
                query(collection(db, "courses"), where("schoolId", "==", selectedSchoolObj.id))
            );
            const coursesData = coursesSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })) as Course[];
            setCourses(coursesData.sort((a, b) => a.name.localeCompare(b.name)));

            // Set the new course as selected
            setValue("selectedCourseOption", newCourseName.trim());
            setNewCourseName('');
        } catch (error) {
            console.error("Error adding new course:", error);
        }
    };

    const onCreatePost = async (data: CreateFormData) => {
        const postsRef = collection(db, "posts");
        
        await addDoc(postsRef, {
            title: data.title,
            description: data.description,
            hyperlink: data.hyperlink,
            pdflink: data.pdflink,
            username: user?.displayName,
            userId: user?.uid,
            selectedCourseOption: data.selectedCourseOption,
            selectedSchoolOption: data.selectedSchoolOption,
            selectedUnitOption: data.selectedUnitOption,
            createdAt: serverTimestamp()
        });

        navigate("/");
    };

    const canCreatePosts = () => {
        return userRole.isAdmin || userRole.canCreatePosts;
    };
    
    const canManageUnitsForContent = () => {
        return userRole.isAdmin || userRole.canManageUnits;
    };

    const canManageCoursesForSchool = (schoolName: string) => {
        if (userRole.isAdmin) return true;
        if (!userRole.canManageCourses) return false;
        
        const selectedSchoolObj = schools.find(s => s.name === schoolName);
        if (!selectedSchoolObj) return false;
        
        return userRole.allowedSchools?.includes(selectedSchoolObj.id) || false;
    };

    return(
        <div>
            {!canCreatePosts() ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <h2>Access Restricted</h2>
                    <p>You don't have permission to create posts. Please contact an administrator.</p>
                </div>
   ) : (
       <>
           <h1><span className="gradient-text-ace">Upload Assignment</span></h1>
           <form onSubmit={handleSubmit(onCreatePost)} className="forms-wrapper">
       
           <div className="assignment-container">
               <input placeholder="Title..." {...register("title")} className="titleinput"/>
               <p style={{color:"red"}}>{errors.title?.message}</p>
               <textarea placeholder="Write a short description here"{...register("description")}  className="textArea"/>
               <p style={{color: "red"}}>{errors.description?.message}</p>
               <br />
               
               <input placeholder="Paste hyperlink here" {...register("hyperlink")} className="hyperlink-width" />
               <p style={{color:"red"}}>{errors.hyperlink?.message}</p>
               <input placeholder="Paste PDF link here" {...register("pdflink")} className="hyperlink-width" />
               <p style={{color: "red"}}>{errors.pdflink?.message}</p>
           </div>
           <br />
           
           <div className="course-container">
               <h3>School:</h3>
               <select {...register("selectedSchoolOption")} className="uploadcursor">
                   <option value="">Select a school</option>
                   {schools.map((school) => (
                       <option key={school.id} value={school.name}>{school.name}</option>
                   ))}
                   {userRole.isAdmin && (
                       <option value="__add_new__">+ Add New School</option>
                   )}
               </select>
               <p style={{color:"red"}}>{errors.selectedSchoolOption?.message}</p>

               {watchedSchool === "__add_new__" && userRole.isAdmin && (
                   <div style={{ marginTop: '10px' }}>
                       <input
                           type="text"
                           placeholder="Enter new school name"
                           value={newSchoolName}
                           onChange={(e) => setNewSchoolName(e.target.value)}
                           className="hyperlink-width"
                       />
                       <button
                           type="button"
                           onClick={handleAddNewSchool}
                           style={{ marginLeft: '10px', padding: '5px 10px' }}
                       >
                           Add School
                       </button>
                   </div>
               )}

               <h3>Course:</h3>
               <select 
                   {...register("selectedCourseOption")} 
                   className="uploadcursor"
                   disabled={!selectedSchool || selectedSchool === "__add_new__"}
               >
                   <option value="">Select a course</option>
                   {courses.map((course) => (
                       <option key={course.id} value={course.name}>{course.name}</option>
                   ))}
                   {selectedSchool && selectedSchool !== "__add_new__" && canManageCoursesForSchool(selectedSchool) && (
                       <option value="__add_new__">+ Add New Course</option>
                   )}
               </select>
               <p style={{color:"red"}}>{errors.selectedCourseOption?.message}</p>

               {watchedCourse === "__add_new__" && canManageCoursesForSchool(selectedSchool) && (
                   <div style={{ marginTop: '10px' }}>
                       <input
                           type="text"
                           placeholder="Enter new course name"
                           value={newCourseName}
                           onChange={(e) => setNewCourseName(e.target.value)}
                           className="hyperlink-width"
                       />
                       <button
                           type="button"
                           onClick={handleAddNewCourse}
                           style={{ marginLeft: '10px', padding: '5px 10px' }}
                       >
                           Add Course
                       </button>
                   </div>
               )}

               <h3>Unit:</h3>
               {!showNewUnitInput ? (
                   <div>
                       <select 
                           {...register("selectedUnitOption")} 
                           className="uploadcursor"
                           disabled={!selectedCourse || selectedCourse === "__add_new__"}
                           onChange={(e) => {
                               if (e.target.value === "__add_new__") {
                                   setShowNewUnitInput(true);
                                   setValue("selectedUnitOption", "");
                               }
                           }}
                       >
                           <option value="">Select a unit</option>
                           {units.map((unit, index) => (
                               <option key={index} value={unit}>{unit}</option>
                           ))}
                           {canManageUnitsForContent() && (
                                <option value="__add_new__">+ Add New Unit</option>
                            )}
                       </select>
                   </div>
               ) : (
                   <div>
                       <input
                           {...register("selectedUnitOption")}
                           placeholder="Enter new unit name"
                           className="hyperlink-width"
                       />
                       <button
                           type="button"
                           onClick={() => {
                               setShowNewUnitInput(false);
                               setValue("selectedUnitOption", "");
                           }}
                           style={{ marginLeft: '10px', padding: '5px 10px' }}
                       >
                           Cancel
                       </button>
                   </div>
               )}
               <p style={{color:"red"}}>{errors.selectedUnitOption?.message}</p>
               
               <br></br><br></br>
               <input type="submit" className="custom-red-button" value="Post" />
               <br />
           </div>
       </form>
       </>
   )}
</div>
    );}
